import PropTypes from 'prop-types';

export const UserMenu = ({ logoutButton }) => {
  return (
    <nav className="snn-user-menu-wrapper">
      <div>
        <span className="snn-user-menu-icon material-symbols-outlined">home</span>
        <p className="snn-user-menu-text">Inicio</p>
      </div>
      <div>
        <span className="material-symbols-outlined">library_books</span>
        <p className="snn-user-menu-text">Resúmenes</p>
      </div>
      <div className="">
        <span className="snn-user-menu-icon material-symbols-outlined">add</span>
        <p className="snn-user-menu-text">Agregar resumen</p>
      </div>
      <div onClick={logoutButton}>
        <span className="material-symbols-outlined">logout</span>
        <p className="snn-user-menu-text">Cerrar sesión</p>
      </div>
    </nav>
  );
};

UserMenu.propTypes = {
  logoutButton: PropTypes.func,
};
